<!--
Author: Lsc
Date: 2019-07-25
Desc: 上传身份证ocr验证
 -->
<template>
    <div class="ocr-upd comp">
        <el-dialog
            class="prop"
            :title="title"
            :visible="visible"
            :width="width"
            :before-close="dialogClose"
        >
            <div class="ocr-upd-tip">
                <img src="@/assets/img/icon-warning.png" alt="" />
                <span>
                    单张图片不得超过{{ $cache.getOcrFileSize() }}M;仅支持bmp、jpg、jpeg、png格式
                </span>
            </div>
            <el-row class="up-list-ocr-dialog" :span="24">
                <el-form :model="img">
                    <el-form-item label="">
                        <div class="img-up-box">
                            <div class="img-up-list el-upload-list--picture-card">
                                <div
                                    v-if="imgBase64.backImage"
                                    class="el-upload-list__item-actions"
                                >
                                    <i
                                        class="el-icon-delete"
                                        aria-hidden="true"
                                        v-on:click="delImg('backImage')"
                                    />
                                </div>
                                <el-input
                                    v-model="img.backImage"
                                    type="file"
                                    name="backImage"
                                    :accept="accept"
                                    v-on:change="getImgBase"
                                />
                                <div class="img-up img-load-status">
                                    <img
                                        v-if="imgBase64.backImage"
                                        :src="imgBase64.backImage"
                                        alt=""
                                    />
                                    <img
                                        v-else
                                        :src="require('../../assets/img/ocrback.png')"
                                        alt=""
                                    />
                                </div>
                                <span>身份证人像面</span>
                            </div>
                            <div class="img-up-list el-upload-list--picture-card">
                                <div
                                    v-if="imgBase64.faceImage"
                                    class="el-upload-list__item-actions"
                                >
                                    <i
                                        class="el-icon-delete"
                                        aria-hidden="true"
                                        v-on:click="delImg('faceImage')"
                                    />
                                </div>
                                <el-input
                                    v-model="img.faceImage"
                                    type="file"
                                    name="faceImage"
                                    :accept="accept"
                                    v-on:change="getImgBase"
                                />
                                <div class="img-up img-load-status">
                                    <img
                                        v-if="imgBase64.faceImage"
                                        :src="imgBase64.faceImage"
                                        alt=""
                                    />
                                    <img
                                        v-else
                                        :src="require('../../assets/img/ocrover.png')"
                                        alt=""
                                    />
                                </div>
                                <span>身份证国徽面</span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="" class="btn-center">
                        <el-button class="medium dc-cancel-btn" v-on:click="dialogClose">
                            还未准备好
                        </el-button>
                        <el-button
                            type="primary"
                            class="medium confirm"
                            :disabled="btnStatus"
                            v-on:click="submitInfo()"
                        >
                            确定上传
                        </el-button>
                    </el-form-item>
                </el-form>
                <div class="cut-off-line top">
                    <span>请按正确示例上传证件照</span>
                </div>
                <img src="@/assets/img/ocr-example.png" class="example" alt="" />
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import commonApi from "@/api/common";
export default {
    name: "OrcUpdDialog",
    props: {
        title: {
            type: String,
            default: "上传证件照"
        },
        width: {
            type: String,
            default: "740px"
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogImageUrl: "",
            accept: "image/bmp,image/png,image/jpg,image/jpeg",
            img: {
                faceImage: "",
                backImage: ""
            },
            imgBase64: {
                faceImage: "",
                backImage: ""
            }
        };
    },
    computed: {
        btnStatus: function () {
            return !(this.imgBase64.faceImage && this.imgBase64.backImage);
        }
    },
    watch: {},
    methods: {
        dialogClose() {
            this.$emit("back");
            this.cancel();
        },
        async submitInfo() {
            const params = {
                frontphoto: this.imgBase64.faceImage.split(",")[1],
                backphoto: this.imgBase64.backImage.split(",")[1],
                photo: this.imgBase64.backImage.split(",")[1],
                mode: "1"
            };
            const resp = await commonApi.ocr(params);
            if (resp.error) return;
            this.$emit("success", {
                ...resp.data,
                vailddate: resp.data.validate
            });
            this.dialogClose();
            this.$message({
                type: "success",
                message: "上传证件成功！"
            });
        },
        cancel() {
            this.img = {
                faceImage: "",
                backImage: ""
            };
            this.imgBase64 = {
                faceImage: "",
                backImage: ""
            };
        },
        getImgBase() {
            const _this = this;
            const event = window.event;
            const file = event.target && event.target.files[0];
            let k = 0;
            if (!file) {
                this.delImg(event.target.name);
                return false;
            }
            let maxSize = this.$cache.getOcrFileSize();
            if (file.size > 1024 * 1024 * maxSize) {
                this.img[event.target.name] = "";
                this.$message.warning("上传文件大小超过限制大小" + maxSize + "M，不能上传");
                return;
            }
            for (var i in this.img) {
                if (this.img[i] && file.name === this.img[i].split("\\").pop()) k++;
            }
            if (k === 2) {
                this.delImg(event.target.name);
                this.$message.warning("不能上传相同名称的文件，请重新上传");
                return false;
            }
            const reader = new FileReader();
            // 转base64
            reader.onload = function (e) {
                _this.$set(_this.imgBase64, event.target.name, e.target.result);
            };
            reader.readAsDataURL(file);
        },
        // 删除图片
        delImg(index) {
            this.imgBase64[index] = "";
            if (this.img[index]) {
                this.img[index] = "";
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
:deep(.el-dialog__wrapper.prop .el-dialog__body) {
    padding: 0;
}

.ocr-upd-tip {
    background: #fffaf6;
    height: 40px;
    display: flex;
    align-items: center;
    color: #999;
    font-size: 14px;
    img {
        width: 18px;
        height: 18px;
        margin: 0 8px 0 20px;
    }
}

.up-list-ocr-dialog {
    padding: 0 20px;
    .img-up-list {
        margin: 50px 0px 30px;
        display: inline-block;
        position: relative;
        .el-upload-list__item-actions {
            z-index: 100;
            i {
                font-size: $f24;
                cursor: pointer;
            }
            i:last-of-type {
                margin-left: 20px;
            }
        }
        .el-input {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            z-index: 10;
        }
        .img-up,
        :deep(.el-input .el-input__inner) {
            width: 320px;
            height: 182px;
            line-height: 182px;
            cursor: pointer;
        }

        .img-up {
            text-align: center;
            border: 3px dashed $border-color4;
            border-radius: 10px;
            background-color: $bg1;
            overflow: hidden;
            img {
                width: 320px;
                height: 182px;
                display: inline-block;
            }
            &.img-load-status {
                width: 320px;
                height: 182px;
                border: none;
                border-radius: 6px;
            }
        }
        .img-text {
            vertical-align: middle;
            font-size: $f20;
        }
        .el-icon-plus {
            vertical-align: middle;
            font-size: $f26;
            margin-right: 7px;
            color: inherit;
            font-weight: bold;
        }
    }
    .img-up-box {
        text-align: center;
        font-size: 16px;
        .img-up-list {
            vertical-align: middle;
            &:last-of-type {
                margin-left: 20px;
            }
        }
        span {
            margin-top: 12px;
            line-height: 16px;
            display: block;
        }
    }
    .el-form-item__error {
        top: 90%;
        left: 50%;
        -webkit-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    .btn-center {
        text-align: center;
        .confirm {
            width: 180px;
            margin-left: 40px;
        }
    }
    .cut-off-line.top {
        margin: 38px 0 13px;
    }
    .example {
        margin: 0 auto 40px;
        display: block;
    }
}
</style>
